import { Component, Input, ViewEncapsulation } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { CerrixHoverCardDirective } from "../cerrix-hover-card/cerrix-hover-card.directve";

@Component({
    selector: "cerrix-instructions-icon",
    imports: [MatIcon, CerrixHoverCardDirective],
    templateUrl: "./cerrix-instructions-icon.component.html",
    styleUrl: "./cerrix-instructions-icon.component.scss",
    encapsulation: ViewEncapsulation.None,
})
export class CerrixInstructionsIconComponent {
    @Input() instructionText: string = "";
    @Input() showText: boolean = true;
}
